import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import B2BOrganisationForm from './B2BOrganisationForm';

export default function NewB2BOrganisationScreen() {
  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create New Organisation"
          items={[{ name: 'B2B', url: '/b2b' }]}
        />

        <B2BOrganisationForm />
      </Stack>
    </ScreenWrap>
  );
}
